/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Askquestion_Title2Inputs */

const en_coinvestments_messages_askquestion_title2 = /** @type {(inputs: Coinvestments_Messages_Askquestion_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask a question`)
};

/**
* | output |
* | --- |
* | "Ask a question" |
*
* @param {Coinvestments_Messages_Askquestion_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_askquestion_title2 = /** @type {((inputs?: Coinvestments_Messages_Askquestion_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Askquestion_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_askquestion_title2(inputs)
});
export { coinvestments_messages_askquestion_title2 as "coInvestments_messages_askQuestion_title" }